import React, { useState, useEffect } from 'react';
import DataTable from '../Shared/DataTable';

const Sales = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setSales([
        { id: 101, user: 'Jean Dupont', product: 'Abonnement Premium', amount: '29.99€', date: '2023-10-25', status: 'completed' },
        { id: 102, user: 'Marie Martin', product: 'Badge Vérifié', amount: '9.99€', date: '2023-10-24', status: 'completed' },
        { id: 103, user: 'Paul Durand', product: 'Pack Publicité', amount: '150.00€', date: '2023-10-23', status: 'pending' },
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    { header: 'ID', accessor: 'id' },
    { header: 'Utilisateur', accessor: 'user' },
    { header: 'Produit', accessor: 'product' },
    { header: 'Montant', accessor: 'amount' },
    { header: 'Date', accessor: 'date' },
    { 
      header: 'Statut', 
      accessor: 'status',
      render: (item) => (
        <span className={`status-badge ${item.status === 'completed' ? 'status-success' : 'status-warning'}`}>
          {item.status === 'completed' ? 'Payé' : 'En attente'}
        </span>
      )
    }
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>Historique des Ventes</h2>
      </div>
      <DataTable 
        title="Dernières Transactions" 
        columns={columns} 
        data={sales} 
        loading={loading}
        onSearch={(val) => console.log(val)}
      />
    </div>
  );
};

export default Sales;
